// iOS PWA install hint. iOS Safari has no beforeinstallprompt event;
// the user has to use Share → Add to Home Screen. We render a one-time
// dismissible banner if we detect iOS Safari running outside standalone.

import { el } from './dom.js';

const STORAGE_KEY = 'mefit.install.dismissedAt';
const DISMISS_DAYS = 30;

type IOSNavigator = Navigator & { standalone?: boolean };

function isIOS(): boolean {
  const ua = navigator.userAgent;
  const isIPad = /iPad/.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  return /iPhone|iPod/.test(ua) || isIPad;
}

function isStandalone(): boolean {
  if ((navigator as IOSNavigator).standalone) return true;
  if (window.matchMedia('(display-mode: standalone)').matches) return true;
  return false;
}

function isSafari(): boolean {
  const ua = navigator.userAgent;
  // iOS Safari and Chrome on iOS both show the banner — both need the share menu.
  // Only exclude in-app browsers (FB, IG) where Add to Home is unavailable.
  return !/FBAN|FBAV|Instagram|Line/i.test(ua);
}

function isDismissed(): boolean {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (!v) return false;
    const at = Number(v);
    if (!Number.isFinite(at)) return false;
    return Date.now() - at < DISMISS_DAYS * 24 * 60 * 60 * 1000;
  } catch {
    return false;
  }
}

function dismiss() {
  try {
    localStorage.setItem(STORAGE_KEY, String(Date.now()));
  } catch {
    /* ignore */
  }
}

export function maybeShowInstallHint() {
  if (!isIOS() || isStandalone() || isDismissed() || !isSafari()) return;

  const banner = el(
    'div',
    { class: 'install-hint', role: 'dialog' },
    [
      el('div', { class: 'install-hint__text' }, [
        'Instalar como app: tocar em ',
        el('span', { class: 'install-hint__share', 'aria-label': 'compartilhar' }, ['􀈂']),
        ' e ',
        el('strong', {}, ['Adicionar à Tela Inicial']),
        '.',
      ]),
      el('button', {
        class: 'install-hint__close',
        type: 'button',
        'aria-label': 'Dispensar',
        onclick: () => {
          dismiss();
          banner.remove();
        },
      }, ['×']),
    ],
  );

  document.body.append(banner);
}
